import { graphql } from "relay-runtime"

export const deVerifyHealthInformationMutation = graphql`
  mutation deVerifyHealthInformationMutation($input: De_verifyHealthInformationInput!) {
    verifyHealthInformation: de_verifyHealthInformation(input: $input) {
      verifyHealthInformationOutput {
        healthInformationLastVerification {
          id
          patientId
          healthInformationType
          verifiedAt
          verifiedBy
        }
        healthInformationVerification {
          id
          patientId
          appointmentId
          healthInformationType
          verifiedAt
          verifiedBy
        }
      }
    }
  }
`
